/**
 * Amplitude analytics events
 */
;(function () {
  var body = document.querySelector('body')
  if (!body) return
  var bodyData = body.dataset || {}
  var template = bodyData.template || ''

// ---------- page_view ----------
  if (window.is_amplitude_enabled && window.amplitude) {
    window.amplitude.track('page_view', {
      page_name: bodyData.pageName || template || 'page',
      signin: bodyData.signin === 'true',
    })
  }

  // ---------- cart_viewed ----------
  if (template === 'cart') {
    if (window.is_amplitude_enabled && window.amplitude) {
      window.amplitude.track('cart_viewed', {
        signin: bodyData.signin === 'true',
        try_on_completed: false,
      })
    }
  }

  // ---------- product_viewed ----------
  if (template === 'product') {
    if (window.is_amplitude_enabled && window.amplitude) {
      var ds = bodyData
      var signinValue = ds.signin === 'true'
      var priceCents = ds.productPrice ? parseInt(ds.productPrice, 10) : null
      var price = priceCents != null ? (priceCents % 1 !== 0 ? priceCents / 100 : priceCents / 100) : null
      var referrer = typeof document.referrer === 'string' ? document.referrer : ''
      var source = 'direct'
      try {
        if (referrer) {
          var refUrl = new URL(referrer)
          if (refUrl.origin === window.location.origin) {
            var path = (refUrl.pathname || '').toLowerCase()
            if (path.indexOf('/search') !== -1) source = 'search'
            else if (path.indexOf('/cart') !== -1) source = 'cart'
            else if (path.indexOf('/collections/') !== -1) source = 'collection'
            else if (path.indexOf('wishlist') !== -1) source = 'wishlist'
            else if (path.indexOf('/account') !== -1) source = 'account'
            else if (path === '/' || path === '') source = 'home'
            else source = 'other'
          } else source = 'external'
        }
      } catch (e) {}
      var props = { signin: signinValue, try_on_completed: false, source: source }
      if (ds.productId) props.id = ds.productId
      if (ds.productSku) props.sku = ds.productSku
      if (price != null) props.price = price
      if (ds.productCategory) props.product_category = ds.productCategory
      if (ds.productBrand) props.product_brand = ds.productBrand
      window.amplitude.track('product_viewed', props)
    }
  }

  // ---------- email_submitted (newsletter) ----------
  document.querySelectorAll('form[data-ga-name="newsletter_form"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      if (window.is_amplitude_enabled && window.amplitude) {
        window.amplitude.track('email_submitted', { description: 'user submitted email' })
      }
    })
  })

  // ---------- login (account page) ----------
  if (template === 'account') {
    var isLoginReferal = sessionStorage.getItem('loginFormSubmitted')
    if (isLoginReferal && window.is_amplitude_enabled && window.amplitude) {
      window.amplitude.track('login', { status: 'login successful' })
    }
  }

  // ---------- added_to_cart (GA_ADD_TO_CART) ----------
  window.addEventListener('GA_ADD_TO_CART', function (event) {
    var item = (event.detail && event.detail.item) || null
    if (!item) return
    var lineItem = item.items && item.items[0] ? item.items[0] : item
    var signinValue = bodyData.signin === 'true'
    var price = lineItem.price != null ? (lineItem.price % 1 !== 0 ? lineItem.price / 100 : lineItem.price) : null
    if (!window.is_amplitude_enabled || !window.amplitude) return
    var props = { signin: signinValue }
    if (lineItem.id != null) props.id = lineItem.id
    if (lineItem.sku != null) props.sku = lineItem.sku
    if (price != null) props.price = price
    if (lineItem.product_type != null) props.product_category = lineItem.product_type
    if (lineItem.vendor != null) props.product_brand = lineItem.vendor
    window.amplitude.track('added_to_cart', props)
  })

  // ---------- checkout_started ----------
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target
      var isCheckoutSubmit =
        form && form.action && form.action.indexOf('cart') !== -1 &&
        (e.submitter && (e.submitter.name === 'checkout' || e.submitter.getAttribute('name') === 'checkout'))
      if (!isCheckoutSubmit) return
      if (!window.is_amplitude_enabled || !window.amplitude) return
      e.preventDefault()
      var checkoutUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '') + '/checkout'
      var cartUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js'
      fetch(cartUrl)
        .then(function (r) { return r.json() })
        .then(function (cart) {
          var items = cart.items || []
          var first = items[0]
          var price = first && first.price != null ? (first.price % 1 !== 0 ? first.price / 100 : first.price) : null
          var props = { try_on_completed: false }
          if (first && first.id != null) props.id = first.id
          if (first && first.sku != null) props.sku = first.sku
          if (price != null) props.price = price
          if (first && first.product_type != null) props.product_category = first.product_type
          if (first && first.vendor != null) props.product_brand = first.vendor
          window.amplitude.track('checkout_started', props)
          setTimeout(function () { window.location.href = checkoutUrl }, 150)
        })
        .catch(function () { window.location.href = checkoutUrl })
    },
    true
  )

  // ---------- search_opened ----------
  function fireAmplitudeSearchOpened(triggerEl) {
    if (!window.is_amplitude_enabled || !window.amplitude) return
    var input = triggerEl.matches && triggerEl.matches('[data-ga-el="searchInput"]')
      ? triggerEl
      : (triggerEl.closest && (triggerEl.closest('form[role="search"]') || triggerEl.closest('.search'))) && (triggerEl.closest('form[role="search"]') || triggerEl.closest('.search')).querySelector('[data-ga-el="searchInput"]')
    var query = (input && input.value) ? input.value.trim() : ''
    var source = 'header'
    if (triggerEl.closest && (triggerEl.closest('.hd-Drawer') || triggerEl.closest('[class*="drawer"]') || triggerEl.closest('[id*="drawer"]'))) {
      source = 'drawer'
    }
    window.amplitude.track('search_opened', {
      signin: bodyData.signin === 'true',
      query: query,
      source: source,
    })
  }
  document.querySelectorAll('[data-ga-el="searchIcon"]').forEach(function (el) {
    el.addEventListener('click', function () { fireAmplitudeSearchOpened(el) })
  })
  document.querySelectorAll('[data-ga-el="searchInput"]').forEach(function (inputEl) {
    inputEl.addEventListener('focus', function () { fireAmplitudeSearchOpened(inputEl) })
  })

  // ---------- size_selected (PDP) ----------
  if (template.indexOf('product') !== -1) {
    var pdpSizeEls = document.querySelectorAll('[data-ga-el="pdpSizeClick"]')
    pdpSizeEls.forEach(function (input) {
      input.addEventListener('click', function (e) {
        if (!window.is_amplitude_enabled || !window.amplitude) return
        var el = e.currentTarget
        var ds = el.dataset || {}
        var priceCents = ds.gaVariantPrice ? parseInt(ds.gaVariantPrice, 10) : null
        var price = priceCents != null ? (priceCents % 1 !== 0 ? priceCents / 100 : priceCents / 100) : null
        var props = { try_on_completed: false }
        if (ds.variantId) props.id = ds.variantId
        if (ds.gaVariantSku) props.sku = ds.gaVariantSku
        if (price != null) props.price = price
        if (bodyData.productCategory) props.product_category = bodyData.productCategory
        if (bodyData.productBrand) props.product_brand = bodyData.productBrand
        window.amplitude.track('size_selected', props)
      })
    })
  }
})()
